import { escapeHTML } from '../../utils';

class Results {
  constructor(options) {
    this.question = options;
  }

  renderAnswers() {
    let answerHtml = '';
    let answers = '';

    this.question.answers.map((answer) => {
      answerHtml = `
        <div class="resultShortAns">
          <div class="resultShortAnsText">
            ${escapeHTML(answer.body)}
          </div>

          <div class="resultShortAnsBarContainer">
            <div id="resultShortAnsBar-${answer.id}" class="resultShortAnsBar ${
        answer.isMax
      }" style="width: 0%"></div>
          </div>

          <div class="resultShortAnsPercentage">
            ${answer.percentage}%
          </div>

          <div class="clearer"></div>
          <div class="horizontalLine"></div>
        </div>
      `;
      answers += answerHtml;
      return true;
    });

    return answers;
  }

  renderResult() {
    let result = '';
    result = `
      <div class="resultShortAllAns">
        ${this.renderAnswers()}
      </div>
    `;
    return result;
  }

  render() {
    let results = '';

    results = `
      <div class="resultShortContainer">
        <div class="resultTickShort">
          <div class="resultTickTextShort">
            &#10003;
          </div>
        </div>

        <div class="resultShortPrompt">
          ${this.question.prompt}
        </div>

        <div id="hintForQuestionTypeShort">
          &#x25cf; VOTES
        </div>

        ${this.renderResult()}
      </div>
    `;
    return results;
  }
}

export default Results;
